let create = function (category, data, legend) {
  let ydata = [];
  if (legend) {
    ydata = legend.map((l, index) => {
      return {
        name: l,
        type: "line",
        stack: "总量",

        data: data[index],
        itemStyle: {
          normal: {
            lineStyle: {
              color: "#4DA1FF"
            }
          }
        },
        areaStyle: {
          normal: { color: "#DFEDFE" }
        }
      };
    });
  } else {
    ydata = [
      {
        name: this.config.Title,
        type: "line",
        stack: "总量",
        smooth: true,
        data: data,
        itemStyle: {
          color: "#2293FB", // 线颜色
        },
 
      }
    ];
  }
  return {

    title: {
      // text: this.config.Title || "",
      // subtext: this.config.SubTitle || "",
      left: "center"
    },
    legend: legend
      ? {
        data: legend
      }
      : null,
    tooltip: {
      trigger: "axis",
      backgroundColor: "#4d8bf7",
      color: "#ffffff",
      textStyle: {
        color: "#ffffff"
      },
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#6a7985"
        }
      }
    },
    // 设置网格样式
    grid: {
      show: true, // 显示边框
      top: "20%",
      left: "3%",
      right: "4%",
      bottom: "3%",
      borderColor: "#f7f7f7", // 边框颜色
      containLabel: true, // 包含刻度文字在内
    },
    xAxis: [
      {
        type: "category",
        axisTick: {
          show: false, //去除刻度线
        },
        axisLabel: {
          color: "#4c9bfd", //文本颜色
        },
        axisLine: {
          show: false, //去除轴线
        },
        boundaryGap: false, //去除轴内间距
        data: category
      }
    ],
    yAxis: [
      {
        type: "value",
        axisTick: {
          show: false, //去除刻度线
        },
        axisLabel: {
          color: "#4c9bfd", //文本颜色
        },
        axisLine: {
          show: false, //去除轴线
        },
        boundaryGap: false, //去除轴内间距
      }
    ],
    series: ydata
  };
};

export default { create };
